// assets
import { DashboardOutlined, CalendarOutlined } from '@ant-design/icons';

// icons
const icons = {
  DashboardOutlined,
  CalendarOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'group-dashboard',
  title: '',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard',
      icon: icons.DashboardOutlined,
      breadcrumbs: false
    },
    {
      id: 'vacation',
      title: 'Time Off',
      type: 'item',
      url: '/vacation',
      icon: icons.CalendarOutlined,
      breadcrumbs: false,
      requiredFeature: 'vacation_tracking'
    }
  ]
};

export default dashboard;
